import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import HandymanIcon from "@mui/icons-material/Handyman";
import RestoreIcon from "@mui/icons-material/Restore";
import { Button, Paper, Radio, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import chatList from "../HelpInteraction/chatList.json";
import ChatComponent from "./ChatComponent";
import { useStyles } from "./HelpStyle";

export interface IFixOrRestoreActionBox {
  displayNextSlide: () => void;
}

const FixOrRestoreActionBox = (props: IFixOrRestoreActionBox) => {
  const classes = useStyles();

  const levelOptionsList = [
    {
      level: "a",
      list: ["Fix imaging machines"],
      icon: <HandymanIcon />,
    },
    {
      level: "b",
      list: ["Restore backups"],
      icon: <RestoreIcon />,
    },
  ];

  const handleClick = () => {
    if (selectedValue === "a") {
      setShowChat(false);
      props.displayNextSlide();
    } else if (selectedValue === "b") {
      setShowChat(true);
    }
  };
  const [selectedValue, setSelectedValue] = React.useState("");
  const [showChat, setShowChat] = React.useState(false);
  const hideChat = () => {
    setShowChat(false);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(event.target.value);
  };

  return (
    <Box>
      <Box className={classes.actionBox}>
        <Paper className={classes.actionBoxOptionsDiv} style={{ zIndex: -2 }}>
          <Typography sx={{ fontSize: "1.8rem", fontWeight: "700" }}>
            Select an option
          </Typography>
          <div style={{ margin: "1rem 0" }}>
            {levelOptionsList.map((element, index) => {
              return (
                <label
                  htmlFor={element.level}
                  style={{ cursor: "pointer" }}
                  key={index}
                >
                  <Paper className={classes.actionBoxPill}>
                    <div
                      style={{
                        boxSizing: "border-box",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        margin: "0 1rem",
                      }}
                    >
                      <Radio
                        id={element.level}
                        checked={selectedValue === element.level}
                        onChange={handleChange}
                        value={element.level}
                        name="radio-buttons"
                        inputProps={{ "aria-label": "A" }}
                        className={classes.customRadioStyle}
                      />
                    </div>
                    <div className={classes.levelDiv}>
                      {element.icon}
                      <Typography className={classes.levelText}>
                        {element.list}
                      </Typography>
                    </div>
                  </Paper>
                </label>
              );
            })}
          </div>
          <Button
            sx={{
              borderRadius: "3rem",
              textTransform: "capitalize",
              padding: "1rem 2.2rem",
              fontSize: "1.1rem",
              fontWeight: "600",
            }}
            variant="contained"
            endIcon={<ArrowForwardIcon />}
            onClick={handleClick}
          >
            Continue
          </Button>
        </Paper>
      </Box>
      {showChat && (
        <ChatComponent chatList={chatList[9]} displayNextSlide={hideChat} />
      )}
    </Box>
  );
};

export default FixOrRestoreActionBox;
